import { queryOptions } from "@tanstack/react-query";

import { bootstrapSession } from "@mountayaapp/auth";

import { ory } from "./ory";

/**
 * VIEWER_SESSION_QUERY_KEY identifies the best-effort viewer whoami in the shared query
 * cache. It is deliberately distinct from the app's own session bootstrap (ensureSession,
 * which reset()s the store to anonymous on a null session) so the share surface can probe
 * for a signed-in viewer without wiping the shared-org seed it layers on top.
 */
const VIEWER_SESSION_QUERY_KEY = ["auth", "viewer-session"] as const;

/**
 * viewerSessionQueryOptions is the cached, best-effort viewer whoami the share route
 * primes in its beforeLoad. Wrapping bootstrapSession in a query — rather than awaiting it
 * raw — makes it behave like every other beforeLoad read: cached, so the router resolving
 * the match more than once (a preload plus the load, a re-validation) reads it from cache
 * instead of re-firing the network whoami, and lifecycle-correct, so an in-flight preload
 * never tears down mid-await into an undefined match. It resolves to the viewer's session,
 * or null when the visitor is anonymous (a 401) or the probe fails — the caller treats null
 * as anonymous, and the session never becomes a read credential (reads ride the share token).
 */
export const viewerSessionQueryOptions = () =>
  queryOptions({
    queryFn: () => bootstrapSession(ory).catch(() => null),
    queryKey: VIEWER_SESSION_QUERY_KEY,
    staleTime: Number.POSITIVE_INFINITY,
  });
